/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { SnapshotUpdater };
class SnapshotUpdater {
    args;
    #current = null;
    #snapshot = null;
    #updating = true;
    constructor(args) {
        this.args = args;
    }
    refresh() {
        this.#snapshot = null;
        this.#updating = true;
        this.latest().catch(() => {
            // eat the errors to remove any weird side effects of calling `refresh`.
        });
    }
    updating() {
        return this.#updating;
    }
    snapshot() {
        return {
            current: this.current(),
            latest: this.latest(),
            updating: this.#updating,
        };
    }
    current() {
        if (!this.#current) {
            this.#current = this.args.initial();
            this.refresh();
        }
        return this.#current;
    }
    async latest() {
        if (this.#snapshot) {
            return this.#snapshot;
        }
        this.#snapshot = this.args.latest().then((latest) => {
            this.args.willUpdate?.(this.current(), latest);
            this.#current = latest;
            this.#updating = false;
            this.args.updated?.(latest);
            return latest;
        });
        return this.#snapshot;
    }
}
//# sourceMappingURL=snapshot-updater.js.map